import { motion } from "framer-motion";
import {
  Droplets,
  Sparkles,
  ShieldCheck,
  Wind,
  Gauge,
  Thermometer,
} from "lucide-react";
import { getServiceSpan } from "@/lib/ui-helpers";
import { CARD_HOVER } from "@/lib/motion-presets";

const ICONS = [Droplets, Sparkles, ShieldCheck, Wind, Gauge, Thermometer];

export default function Services({ t }) {
  return (
    <section id="services" className="py-20 sm:py-32" data-testid="services-section">
      <div className="max-w-7xl mx-auto px-6 sm:px-10">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-8 mb-14 reveal">
          <div className="md:col-span-5">
            <span className="label-eyebrow">{t.services.label}</span>
            <h2 className="font-heading text-4xl sm:text-5xl mt-3">
              {t.services.title}
            </h2>
          </div>
          <div className="md:col-span-6 md:col-start-7">
            <p className="text-lg text-[var(--body)] leading-relaxed">
              {t.services.subtitle}
            </p>
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-12 gap-5">
          {t.services.items.map((item, i) => {
            const Icon = ICONS[i % ICONS.length];
            return (
              <motion.div
                whileHover={CARD_HOVER}
                key={item.title}
                className={`card-surface p-7 sm:p-8 reveal ${getServiceSpan(i)}`}
                data-testid={`service-card-${i}`}
              >
                <div className="w-12 h-12 rounded-xl bg-[var(--secondary)]/15 flex items-center justify-center mb-5">
                  <Icon className="w-6 h-6 text-[var(--primary)]" strokeWidth={1.7} />
                </div>
                <h3 className="font-heading text-xl sm:text-2xl mb-2">{item.title}</h3>
                <p className="text-[var(--body)]">{item.body}</p>
              </motion.div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
